module.exports = __webpack_public_path__ + "static/media/2016118124548-46.9ec56aeb.jpg";